module.exports = __webpack_public_path__ + "img/nicky-pro.eec51c16.jpg";